export const GET_PROFILE_SUCCESSFUL = "GET_PROFILE_SUCCESSFUL";

export const PROFILE_PROCESSING = "PROFILE_PROCESSING";

export const STOP_PROFILE_PROCESSING = "STOP_PROFILE_PROCESSING";
